import settingsKeyPrefix from "./settings-key";

const debug = {
    dev: false,
    head: "{LocalSettings}"
};


// This is DEPRICATED
// problem - normalize function ... and inheritance !!!
// user LocalSettingProto in V4
// if you want to use TS - constructor should have ALL normalize not .normalize() call - double check
export default class LocalSettingsProtoDepricated {

    public localStorageKey      : string
    public _defaultValues       : any
    public autoSave             : boolean

    // localStorageKey - key we use to save data in local storage
    // default values - default values for our settings
    constructor(localStorageKey:string, defaultValues?:any) {
        debug.dev && console.log(debug.head,"constuctor key=",localStorageKey,"defaultValues=", defaultValues);
        this.localStorageKey = settingsKeyPrefix() + localStorageKey;
        this._defaultValues = defaultValues;

        const lsValues = this._readFromLocalStorage();

        debug.dev && console.log("Local storage values before normalize", lsValues)

        this.normalize(lsValues);

        this.autoSave = false;          // if true will call .save() after every this.set
    }

    save() {
        if (debug.dev) console.log(debug.head, ".save()");
        this._writeToLocalStorage(this.toObject());
    }

    saveParam(name:string,value:any) {
        if (this.hasOwnProperty(name)) {
            // @ts-ignore
            this[name] = value;
            this.save();
        } else {
            console.warn("LocalSettingsProto set: setting not specified ", name);
        }
    }

    normalize(value:any) {
        // should be extended
        console.warn("LocalSettingsProto Normalized called this should not happen... issue with inheritance? ")
    }

    toObject() {
        // should be extended
    }

    // well need for filters... strannoe govno
    get(variableName:string) {
        // @ts-ignore
        return this[variableName];
    }

    set(variableName:string, value:any, forceSave=false) {
        if (debug.dev) console.log(debug.head, ".set variable=", variableName, "value=", value, "autoSave=", this.autoSave, "forceSave=", forceSave);
        // @ts-ignore
        this[variableName]=value;

        if (this.autoSave || forceSave) this.save();

        return value;
    }

    setAndSave(variableName:string, value:any) {
        return this.set(variableName, value, true);
    }

    loadFromJSON(data:any) {
        _.mapKeys(data, (value,key) => {
            // @ts-ignore
            this[key] = value;
        })

        this.save();
    }


    _readFromLocalStorage():any {

        let values : any;

        try {
            values = localStorage.getItem(this.localStorageKey);
            values = JSON.parse(values);
        } catch(err) {
            // @ts-ignore
            gdEpicFail('local-settings-not-available',err);
        }

        if (!values) values = {};

        return values;
    }

    _writeToLocalStorage(valuesObject:any) {
        try {
            localStorage.setItem(this.localStorageKey, JSON.stringify(valuesObject));
        } catch (err) {
            window.gdEpicFail("local-settings-not-available",err);
        }

    }

}
